import React from "react";
import InfoSection from "@components/pages/info/info_section";
import ServiceHeader from "@components/pages/info/services/service_header";
import Head from "next/head";
import { WEBPAGE_TITLE } from "@utils/constants";

function ServiceNumber() {
    return (
        <>
            <Head>
                <title key="site_title">Úthringiverkefni - {WEBPAGE_TITLE}</title>
            </Head>
            <InfoSection>
                <ServiceHeader
                    image="/img/thjonusta/uthringiverkefni.png"
                    title="Úthringiverkefni"
                />
                <p>
                    1819 tekur a&eth; s&eacute;r allar tegundir verkefna &iacute; tengslum vi&eth;
                    &uacute;thringingar. Vi&eth; h&ouml;fum teki&eth; a&eth; okkur verkefni &iacute;
                    &ouml;llum st&aelig;r&eth;argr&aacute;&eth;um, fr&aacute; &thorn;v&iacute;
                    a&eth; hringja &iacute; alla b&aelig;ndur landsins yfir &iacute; a&eth; leggja
                    kannanir fyrir vi&eth;skiptavini fyrirt&aelig;kja. Ekkert verk er of
                    st&oacute;rt e&eth;a sm&aacute;tt!
                </p>
                <p>
                    Starfsf&oacute;lk &uacute;thringivers 1819 er &thorn;j&aacute;lfa&eth; til
                    &thorn;ess a&eth; sinna &oacute;l&iacute;kum ger&eth;um &uacute;thringiverkefna
                    &thorn;ar sem lagt er mat &aacute; hvert einstakt verkefni, markmi&eth;
                    &thorn;ess og umfang. S&eacute;rst&ouml;k &aacute;hersla er l&ouml;g&eth;
                    &aacute; fagleg og v&ouml;ndu&eth; samskipti vi&eth; vi&eth;m&aelig;lendur okkar
                    &thorn;ar sem vir&eth;ing fyrir vi&eth;takanda s&iacute;mtalsins, og &thorn;eim
                    uppl&yacute;singum sem &thorn;ar kunna a&eth; koma fram, er h&ouml;f&eth; a&eth;
                    lei&eth;arlj&oacute;si.
                </p>
                <p>1819 tekur me&eth;al annars a&eth; s&eacute;r</p>
                <ul style={{ listStyleType: "circle" }}>
                    <li>Marka&eth;sranns&oacute;knir</li>
                    <li>Vi&eth;horfs- og sko&eth;anakannanir</li>
                    <li>&THORN;j&oacute;nustukannanir</li>
                    <li>Eftirfylgni me&eth; hinum &yacute;msu verkefnum</li>
                    <li>&Ouml;flun n&yacute;rra vi&eth;skiptavina</li>
                </ul>
                <p style={{ textAlign: "left" }}>
                    &THORN;etta er langt fr&aacute; &thorn;v&iacute; a&eth; vera t&aelig;mandi listi
                    yfir ger&eth;ir &thorn;eirra &uacute;thringiverkefna sem vi&eth; sinnum
                    &thorn;ar sem &thorn;&ouml;rf vi&eth;skiptavina okkar hverju sinni
                    r&aelig;&eth;ur f&ouml;r.
                </p>
                <p style={{ textAlign: "center" }}>&nbsp;</p>
                <p style={{ textAlign: "center" }}>
                    <a className="btn btn-primary" href="/um/fyrirtaekid/hafa-samband">
                        Hafa samband
                    </a>
                </p>
            </InfoSection>
        </>
    );
}
export default ServiceNumber;
